import { createVenueOpeningTimes } from 'src/api/createVenueOpeningTimes';
import { formatOpeningTimesPayload } from 'src/helpers/venueFormUtilities';
import { TEditVenueOpeningTimes } from '../../../components/VenueOpeningTimeEditModal/types';
import { IOpeningTimeCreateResponse } from '../../../api/createVenueOpeningTimes/types';

export const createVenueOpeningTimesPromise = (
  venueId: string,
  openingTimes: TEditVenueOpeningTimes,
): Promise<IOpeningTimeCreateResponse>[] => {
  const newOpeningTimes = formatOpeningTimesPayload(openingTimes);

  if (!newOpeningTimes?.schedules.length) return [];

  return [createVenueOpeningTimes(venueId, newOpeningTimes)];
};
